import { Http } from '../../../support';

const initialState = {
  busy: false,
  filters: {
    search: '',
  },
  data: {},
  cliente: {},
  error: undefined,
};

const summary = async (store, id, meta = {}) => {
  store.setState((state) => {
    state.admin.dashboard.info = {
      ...state.admin.dashboard.info,
      busy: true,
      filters: {
        ...state.admin.dashboard.info.filters,
        ...meta,
      },
    };
  });

  try {
    const params = {
      ...meta,
      include: 'empresas,emisores',
    };

    const headers = {
      'X-Tenancy': 'fa/test',
    };

    const response = await Http.get(`api/admin/dashboard/consumo/${id}`, { params, headers });

    store.setState((state) => {
      state.admin.dashboard.info.busy = false;
      state.admin.dashboard.info.data = response.data;
      state.admin.dashboard.info.cliente = response.cliente;
    });
  } catch (error) {
    store.setState((state) => {
      state.admin.dashboard.info.busy = false;
      state.admin.dashboard.info.error = error.data || error;
    });
  }
};

const reset = (store) => (state) => {
  state.admin.dashboard.info = { ...initialState };
};

const DashboardInfoStore = {
  state: () => initialState,
  actions: {
    summary,
    reset,
  },
};

export default DashboardInfoStore;
